// Switch location
export const GET_CUSTOMER_PROFILES = "GET_CUSTOMER_PROFILES";
export const GET_CUSTOMER_PROFILES_SUCCESS = "GET_CUSTOMER_PROFILES_SUCCESS";
export const GET_CUSTOMER_PROFILES_ERROR = "GET_CUSTOMER_PROFILES_ERROR";

export const GET_PERSONALIZATION = "GET_PERSONALIZATION";
export const GET_PERSONALIZATION_SUCCESS = "GET_PERSONALIZATION_SUCCESS";
export const GET_PERSONALIZATION_ERROR = "GET_PERSONALIZATION_ERROR";

export const GET_BOOKMARKS = "GET_BOOKMARKS";
export const GET_BOOKMARKS_SUCCESS = "GET_BOOKMARKS_SUCCESS";
export const GET_BOOKMARKS_ERROR = "GET_BOOKMARKS_ERROR";

export const GET_FOLLOWED_CONTENT_REQUEST = "GET_FOLLOWED_CONTENT_REQUEST";
export const GET_FOLLOWED_CONTENT_SUCCESS = "GET_FOLLOWED_CONTENT_SUCCESS";
export const GET_FOLLOWED_CONTENT_ERROR = "GET_FOLLOWED_CONTENT_ERROR";

export const UNSUBSCRIBE_FOLLOWED_CONTENT_REQUEST =
  "UNSUBSCRIBE_FOLLOWED_CONTENT_REQUEST";
export const UNSUBSCRIBE_FOLLOWED_CONTENT_SUCCESS =
  "UNSUBSCRIBE_FOLLOWED_CONTENT_SUCCESS";
export const UNSUBSCRIBE_FOLLOWED_CONTENT_ERROR =
  "UNSUBSCRIBE_FOLLOWED_CONTENT_ERROR";

export const DELETE_BOOKMARK = "DELETE_BOOKMARK";
export const DELETE_BOOKMARK_SUCCESS = "DELETE_BOOKMARK_SUCCESS";
export const DELETE_BOOKMARK_ERROR = "DELETE_BOOKMARK_ERROR";

export const SHOW_ERROR = "SHOW_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";
